export default __webpack_public_path__ + "static/media/Dynomite.a0f2f917.png";